'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faMessagesQuestion } from '@awesome.me/kit-94e593bf23/icons/classic/regular';
import { faBoxOpen, faFileInvoiceDollar, faSwatchbook } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import ObfuscatedEmail from '@/app/_components/ObfuscatedEmail';
import ChatLink from '@/app/_components/ChatLink';
const imagePairs = [{
  img1: '/images/assistance-block/assistance-a-1.jpg',
  img2: '/images/assistance-block/assistance-a-2.jpg'
}, {
  img1: '/images/assistance-block/assistance-b-1.jpg',
  img2: '/images/assistance-block/assistance-b-2.jpg'
}, {
  img1: '/images/assistance-block/assistance-c-1.jpg',
  img2: '/images/assistance-block/assistance-c-2.jpg'
}, {
  img1: '/images/assistance-block/assistance-d-1.jpg',
  img2: '/images/assistance-block/assistance-d-2.jpg'
}, {
  img1: '/images/assistance-block/assistance-e-1.jpg',
  img2: '/images/assistance-block/assistance-e-2.jpg'
}];
const TradeMemberAssistanceBlockContent = t0 => {
  const $ = _c(30);
  const {
    emailObfuscated
  } = t0;
  const [images, setImages] = useState(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const randomIndex = Math.floor(Math.random() * imagePairs.length);
      setImages(imagePairs[randomIndex]);
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div><span className="block text-3xs tracking-wider text-primary uppercase font-medium mb-1">Need Assistance?</span><div className="text-white text-xl">We Are Happy To Help</div></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon icon={faMessagesQuestion} className="text-sm me-2 mt-1 text-white" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="flex items-start">{t4}<ChatLink className="text-sm text-white hover:text-primary transition-colors">Open the <span className="font-medium">help center</span></ChatLink></div>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faEnvelope} className="text-sm me-2 mt-1 text-white" />;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== emailObfuscated) {
    t7 = <div className="flex items-start">{t6}<span className="text-sm text-white">Email <ObfuscatedEmail obfuscated={emailObfuscated} className="font-medium text-white hover:text-primary" /> and we will respond promptly.</span></div>;
    $[6] = emailObfuscated;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <FontAwesomeIcon icon={faPhone} className="text-sm me-2 mt-1 text-white" />;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex items-start">{t8}<span className="text-sm text-white">Call <a href="tel:18666634483" className="font-medium hover:text-primary">1.866.663.4483</a> to speak to a member of our knowledgeable staff.</span></div>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7) {
    t10 = <div className="flex flex-col justify-start md:justify-between gap-4 flex-1 pl-[var(--site-padding)] pr-5 py-8 bg-light">{t3}{t5}{t7}{t9}</div>;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== images) {
    t11 = images && <Image className="object-cover" src={images.img1} alt="Need Assistance?" fill={true} sizes="(max-width: 1279px) 0px, 16.67vw" />;
    $[12] = images;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <div className="hidden xl:block relative w-1/3 shrink-0">{t11}</div>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t10 || $[17] !== t12) {
    t13 = <div className="flex w-full md:w-1/2">{t10}{t12}</div>;
    $[16] = t10;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mb-4"><span className="block text-3xs tracking-wider text-primary uppercase font-medium mb-1">Trade Member</span><div className="text-xl">Thank You For Your Partnership</div></div>;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Link href="/account/order-history" className="group flex items-center text-sm hover:text-primary transition-colors"><FontAwesomeIcon icon={faBoxOpen} className="text-gray-30 w-5 me-2 group-hover:text-green-600 transition-colors" /><span>View Order History</span></Link>;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Link href="/account" className="group flex items-center text-sm hover:text-primary transition-colors"><FontAwesomeIcon icon={faFileInvoiceDollar} className="text-gray-30 w-5 me-2 group-hover:text-green-600 transition-colors" /><span>Manage Account</span></Link>;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="flex flex-col justify-between flex-1 px-5 py-8 bg-gray-5">{t14}<div className="flex flex-col gap-3 mb-4">{t15}{t16}<Link href="/hive-samples" className="group flex items-center text-sm hover:text-primary transition-colors"><FontAwesomeIcon icon={faSwatchbook} className="text-gray-30 w-5 me-2 group-hover:text-green-600 transition-colors" /><span>Request Swatch Samples</span></Link></div><p className="text-2xs text-light">Your trade pricing is automatically applied at checkout.</p></div>;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== images) {
    t18 = images && <Image className="object-cover" src={images.img2} alt="Trade Member Benefits" fill={true} sizes="(max-width: 1279px) 0px, 16.67vw" />;
    $[23] = images;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t18) {
    t19 = <div className="flex w-full md:w-1/2">{t17}<div className="hidden xl:block relative w-1/3 shrink-0">{t18}</div></div>;
    $[25] = t18;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t13 || $[28] !== t19) {
    t20 = <div className="flex flex-col md:flex-row">{t13}{t19}</div>;
    $[27] = t13;
    $[28] = t19;
    $[29] = t20;
  } else {
    t20 = $[29];
  }
  return t20;
};
export default TradeMemberAssistanceBlockContent;